import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Pages
import RegisterPage from './pages/RegisterPage';
import UsersPage from './pages/UsersPage';
import DashboardPage from './pages/DashboardPage';
import SharedMassPage from './pages/SharedMassPage'; 
import LoginPage from './pages/LoginPage'; 
import AccountManagementPage from './pages/AccountManagementPage'; 
import ProdVitalsPage from './pages/ProdVitalsPage';
import ProdVitalsHistoryPage from './pages/ProdVitalsHistoryPage';
import DnsCheckerPage from './pages/DnsCheckerPage';

// Contexts
import { WorkspacesProvider } from './contexts/WorkspacesContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Layout & Components
import Sidebar from './layout/sidebar/Sidebar';
import AddAccountModal from './components/shared-mass/AddAccountModal';

// --- PRIVATE ROUTE COMPONENT ---
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="d-flex justify-content-center align-items-center vh-100">Loading Auth...</div>;
  }

  return user ? children : <Navigate to="/login" />;
};

// --- PROTECTED LAYOUT ---
const ProtectedLayout = () => {
  const { user } = useAuth();
  const SIDEBAR_WIDTH = '280px';
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const canManage = user?.role === 'ROLE_ADMIN' || user?.role === 'ROLE_MANAGER' || user?.role === 'ROLE_TEAM_LEADER';
  
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="app-container d-flex vh-100">
      <Sidebar onOpenModal={openModal} />

      <main
        className="flex-grow-1 p-0 overflow-y-auto bg-light"
        style={{
          marginLeft: SIDEBAR_WIDTH,
          width: `calc(100% - ${SIDEBAR_WIDTH})`,
        }}
      >
        <Routes>
          {/* Protected*/}
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/shared-mass" element={<SharedMassPage />} />
          
          <Route path="/accounts-management" element={<AccountManagementPage />} /> 
          <Route path="/prod-vitals" element={<ProdVitalsPage />} />
          <Route path="/dns-checker" element={<DnsCheckerPage />} />
          
          <Route 
            path="/prod-vitals-history" 
            element={canManage ? <ProdVitalsHistoryPage /> : <Navigate to="/" />} 
          />

          <Route 
            path="/users" 
            element={canManage ? <UsersPage /> : <Navigate to="/" />} 
          /> 

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>

      <AddAccountModal show={isModalOpen} onClose={closeModal} />
    </div>
  );
};

// --- MAIN APP COMPONENT ---
export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WorkspacesProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />}/>

            {/* Protected Routes Wrapper */}
            <Route 
              path="/*" 
              element={
                <PrivateRoute>
                  <ProtectedLayout />
                </PrivateRoute>
              } 
            />
          </Routes>
        </WorkspacesProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}